<template>
  <main class="view-successful-subscription-payment remove-body-top-padding vh-100-auto d-flex flex-column justify-content-center mx-auto col-xxl-5 col-xl-6 col-lg-7 col-md-8 col-sm-7 col-xxs-12 px-0">
    <div class="d-md-none d-xxs-flex my-sm-5 my-xxs-2 py-4" />
    <header class="bg-success d-flex justify-content-between align-items-center py-3 px-sm-5 px-xxs-3">
      <h2 class="m-0 text-white">
        {{ portalGeneralInfo.title }}
      </h2>
      <div class="rounded-circle bg-success-light p-2">
        <b-img :src="fileUrl" height="90" width="90" />
      </div>
    </header>
    <div class="angles position-relative">
      <div class="angle start position-absolute" />
      <div class="angle end position-absolute" />
    </div>
    <article class="bg-light d-flex py-5 px-md-5 px-xxs-2">
      <img class="d-md-flex d-xxs-none" src="@/assets/icons/qr-code.svg" height="120" width="120">
      <section class="px-4">
        <p class="text-success lead" v-html="$t('UserProfile.Subscription.SuccessfulChargeWalletPayment.SuccessDescription', {FullName:Payment.User.FullName,SubscriptionTime:Payment.Subscription.SubscriptionTime})" />
        <b-container class="p-0">
          <b-row>
            <b-col class="d-md-none d-xxs-block">
              <img class="position-absolute px-3" src="@/assets/icons/qr-code.svg" height="120" width="120">
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label>
                <small class="text-nowrap">
                  {{ $t("UserProfile.Subscription.SuccessfulSubscriptionPayment.Price") }}
                </small>
              </label>
            </b-col>
            <b-col>
              <span>
                <small>{{ Payment.Price.Value }} {{ Payment.Price.Unit }}</small>
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label>
                <small class="text-nowrap">
                  {{ $t("UserProfile.Subscription.SuccessfulSubscriptionPayment.TrackingCode") }}
                </small>
              </label>
            </b-col>
            <b-col>
              <span>
                <small>{{ Payment.Receipt.TrackingCode }}</small>
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label>
                <small class="text-nowrap">
                  {{ $t("UserProfile.Subscription.SuccessfulSubscriptionPayment.PayDate") }}
                </small>
              </label>
            </b-col>
            <b-col cols="3">
              <span>
                <small>{{ Payment.Receipt.Date }}</small>
              </span>
            </b-col>
            <b-col class="col-md-6 col-xxs-12">
              <label class="col-3 p-0">
                <small class="text-nowrap">
                  {{ $t("UserProfile.Subscription.SuccessfulSubscriptionPayment.PayTime") }}
                </small>
              </label>
              <span class="mx-md-3 mx-xxs-0 col-9">
                <small>{{ Payment.Receipt.Time }}</small>
              </span>
            </b-col>
          </b-row>
        </b-container>
        <div class="separator my-4" />
        <section class="d-flex flex-xs-row flex-xxs-column justify-content-between pt-2">
          <b-button variant="primary" class="px-md-4 px-sm-2 mt-md-0 mt-xxs-2" :to="{name:'home'}">
            {{ $t("UserProfile.Subscription.SuccessfulSubscriptionPayment.BestGames", {products: this.globalResources.productTranslation.Plural}) }}
          </b-button>
          <b-button variant="secondary" class="px-md-4 px-sm-2 mt-md-0 mt-xxs-2" :to="{name:'profile'}">
            {{ $t("UserProfile.Subscription.SuccessfulSubscriptionPayment.PaymentHistory") }}
          </b-button>
        </section>
      </section>
    </article>
    <footer class="d-flex flex-md-row flex-xxs-column justify-content-between align-items-center pt-2 pb-1 px-xxs-2 px-sm-5">
      <b-link class="text-decoration-none" :href="portalConfigurations.general.linkToTel">
        {{ portalConfigurations.general.telText }}
      </b-link>
      <b-link class="text-decoration-none" :href="portalConfigurations.general.linkUrl" target="_blank">
        {{ portalConfigurations.general.linkUrl }}
      </b-link>
      <span>
        {{ footer.currentDate }}
      </span>
    </footer>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import utility from '@/utilities/utility.js'

export default {
  name: 'SuccessfullSubscriptionPayment',
  data () {
    return {
      footer: {
        currentDate: new persianDate(new Date()).format('L')
      },
      Payment: {
        Price: {
          Value: 30000,
          Unit: 'تومان',
          InEditMode: false
        },
        Payment: {
          Price: {
            Value: 30000,
            Unit: "تومان",
            InEditMode: false
          },
          Receipt: {
            TrackingCode: "ch30DXG6h7",
            Date: "1397/12/24",
            Time: "16:23"
          },
          User: {
            //UserName: "M_A",
            //FullName: "اسماعیل آزاد",
            //IsSubscribedUser: false,
            //Income: 50000,
            //DownloadedGameCount: 24,
            //PlayedHTMLGameCount: 35
          },
          Subscription: {
            Plan: "",
            SubscriptionTime: ""
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config',
      fileUrlConfiguration: 'cdn/fileUrl',
      userInfo: 'userDemographic/userInfo',
      userPayment: 'order/userPaymentTransaction'
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    },
    fileUrl () {
      if (this.portalConfigurations.general.logoWithTitleUrl) {
        return this.fileUrlConfiguration(
          this.portalConfigurations.general.logoWithTitleUrl
        )
      }
    }
  },
  methods: {
    ...mapActions({
      loadUserInfo: 'userDemographic/loadUserInfo'
    }),
    SetInitialData () {
      if (this.userInfo.username === undefined) {
        this.loadUserInfo().then(response => {
          this.Payment.User = {
            FirstName: response.body.result.firstName !== undefined ? response.body.result.firstName : '',
            LastName: response.body.result.lastName !== undefined ? response.body.result.lastName : '',
            Biography: response.body.result.bio !== undefined ? response.body.result.bio : '',
            UserName: response.body.result.username !== undefined ? response.body.result.username : '',
            Nickname: response.body.result.nickName !== undefined ? response.body.result.nickName : '',
            DateOfBirth: response.body.result.birthDate !== undefined ? response.body.result.birthDate : '',
            Gender: '',
            Cellphone: response.body.result.phoneNumber
              ? response.body.result.phoneNumber
              : '',
            Email: response.body.result.email ? response.body.result.email : ''
            // FullName: response.body.result.firstName + " " + response.body.result.lastName
          }
        })
      } else {
        this.Payment.User = {
          FirstName: this.userInfo.firstName !== undefined ? this.userInfo.firstName : '',
          LastName: this.userInfo.lastName !== undefined ? this.userInfo.lastName : '',
          Biography: this.userInfo.bio !== undefined ? this.userInfo.bio : '',
          UserName: this.userInfo.username !== undefined ? this.userInfo.username : '',
          Nickname: this.userInfo.nickName !== undefined ? this.userInfo.nickName : '',
          DateOfBirth: this.userInfo.birthDate !== undefined ? this.userInfo.birthDate : '',
          Gender: '',
          Cellphone: this.userInfo.phoneNumber !== undefined ? this.userInfo.phoneNumber : '',
          Email: this.userInfo.email !== undefined ? this.userInfo.email : ''
          // FullName: this.userInfo.firstName + " " + this.userInfo.lastName
        }
      }
      this.Payment.User.FullName = this.Payment.User.FirstName + ' ' + this.Payment.User.LastName
      if (this.Payment.User.FullName === ' ') {
        this.Payment.User.FullName = this.Payment.User.Nickname
      }
    }
  },
  mounted () {
    let user = utility.getQueryStringValue('user')
    if (user === '1') {
      this.Payment.User.IsSubscribedUser = true
    }
    this.SetInitialData()
    this.Payment.Price.Value = this.userPayment.amount / 10
    this.Payment.Receipt.TrackingCode = this.userPayment.paymentId
    this.Payment.Receipt.Date = new persianDate(new Date(this.userPayment.paymentDate)).format('L')
    this.Payment.Receipt.Time = new persianDate(new Date(this.userPayment.paymentDate)).format('hh:mm a')
    this.Payment.Subscription.Plan = this.userPayment.lineItem
  },
  created () {
    this.SetInitialData()
    this.Payment.Price.Value = this.userPayment.amount / 10
    this.Payment.Receipt.TrackingCode = this.userPayment.paymentId
    this.Payment.Receipt.Date = new persianDate(new Date(this.userPayment.paymentDate)).format('L')
    this.Payment.Receipt.Time = new persianDate(new Date(this.userPayment.paymentDate)).format('hh:mm a')
    this.Payment.Subscription.Plan = this.userPayment.lineItem
  }

}
</script>
